import { NotificationHistoryChannel } from '@/features/notification-history/types/notification-history-entry';

export type NotificationHistoryFilterData = {
  recipient?: string;
  subject?: string;
  channel?: 'all' | NotificationHistoryChannel;
  sentFrom?: string;
  sentTo?: string;
};

export const defaultNotificationHistoryFilters: NotificationHistoryFilterData = {
  recipient: '',
  subject: '',
  channel: 'all',
  sentFrom: '',
  sentTo: ''
};
